/**
 * Linki z target="_blank" dostają ukryty dopisek dla czytnika ekranu (WCAG 3.2.5).
 */

const NOTE = ' (otwiera się w nowej karcie)';

function mark(root) {
    root.querySelectorAll('a[target="_blank"]:not([data-hn-newtab])').forEach((a) => {
        a.setAttribute('data-hn-newtab', '');
        const label = a.getAttribute('aria-label');
        if (label) {
            a.setAttribute('aria-label', label + NOTE);
            return;
        }
        const span = document.createElement('span');
        span.className = 'screen-reader-text';
        span.textContent = NOTE;
        a.appendChild(span);
    });
}

export function initNewTabLinks() {
    mark(document);
    let queued = false;
    new MutationObserver(() => {
        if (queued) return;
        queued = true;
        setTimeout(() => {
            queued = false;
            mark(document);
        }, 300);
    }).observe(document.body, { childList: true, subtree: true });
}
